import { trackingService } from 'services/tracking/TrackingService.js';
import useUpsertProductTemplate from 'hooks/useUpsertProductTemplate.js';

const useFetchProductMutation = ({ onSuccess, onError, onSettled, trackingContext }) => {
  const eventType = `${trackingContext}:product:add`;

  // Delegate to unified hook; preserve legacy callback shapes and tracking side-effects
  const upsert = useUpsertProductTemplate({
    onSuccess: (body, variables, context) => {
      const wrapped = { body: { ...body, documentId: body.id } };
      onSuccess?.(wrapped, { url: variables.publicUrl }, context);
      trackingService.track({
        eventType,
        value: variables.publicUrl,
        id: body.id,
        affectedIds: body.productReference,
        actionSuccess: true,
      });
    },
    onError: (error, variables, context) => {
      console.log(error);
      onError?.(error, { url: variables.publicUrl }, context);
      trackingService.track({ eventType, value: variables.publicUrl, actionSuccess: false });
    },
    onSettled,
  });

  // Return a wrapper that preserves the original API ({ url })
  return {
    ...upsert,
    mutate: ({ url, ...rest }, options) => upsert.mutate({ publicUrl: url, ...rest }, options),
    mutateAsync: async ({ url, ...rest }, options) => upsert.mutateAsync({ publicUrl: url, ...rest }, options),
  };
};

export default useFetchProductMutation;
